import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { WallTemplate } from './TemplateDrawer';
interface SoffitTemplateDrawerProps {
  isOpen: boolean;
  selectedTemplate: WallTemplate;
  onSelectTemplate: (template: WallTemplate) => void;
  onClose: () => void;
}
export function SoffitTemplateDrawer({
  isOpen,
  selectedTemplate,
  onSelectTemplate,
  onClose
}: SoffitTemplateDrawerProps) {
  const templates: {
    id: WallTemplate;
    name: string;
    description: string;
  }[] = [{
    id: 'free',
    name: 'Free Draw',
    description: 'Draw custom soffit shape'
  }, {
    id: 'rectangle',
    name: 'Rectangle',
    description: 'Rectangular ceiling drop'
  }, {
    id: 'l-shape',
    name: 'L-Shape',
    description: 'L-shaped ceiling drop'
  }, {
    id: 'u-shape',
    name: 'U-Shape',
    description: 'U-shaped ceiling drop'
  }];
  return <AnimatePresence data-id="element-444">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/50 z-40" onClick={onClose} data-id="element-445" />
          <motion.div initial={{
        x: -320
      }} animate={{
        x: 0
      }} exit={{
        x: -320
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 30
      }} className="fixed left-20 top-0 bottom-0 w-80 bg-[#1e1e1e] border-r border-[#333] z-50 overflow-y-auto" data-id="element-446">
            <div className="p-6" data-id="element-447">
              <div className="flex items-center justify-between mb-6" data-id="element-448">
                <div data-id="element-449">
                  <h2 className="text-xl font-bold text-white" data-id="element-450">
                    Soffit Templates
                  </h2>
                  <p className="text-sm text-[#888] mt-1" data-id="element-451">
                    Choose ceiling drop shape
                  </p>
                </div>
                <button onClick={onClose} className="p-2 hover:bg-[#2a2a2a] rounded-lg transition-colors" data-id="element-452">
                  <X size={20} className="text-[#888]" data-id="element-453" />
                </button>
              </div>

              <div className="space-y-3" data-id="element-454">
                {templates.map(template => <motion.button key={template.id} onClick={() => onSelectTemplate(template.id)} className={`w-full p-4 rounded-lg border-2 transition-all text-left ${selectedTemplate === template.id ? 'border-[#8b5cf6] bg-[#8b5cf6]/10' : 'border-[#333] bg-[#2a2a2a] hover:border-[#444]'}`} whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} data-id="element-455">
                    <div className="flex items-start justify-between" data-id="element-456">
                      <div className="flex-1" data-id="element-457">
                        <h3 className="font-semibold text-white mb-1" data-id="element-458">
                          {template.name}
                        </h3>
                        <p className="text-sm text-[#888]" data-id="element-459">
                          {template.description}
                        </p>
                      </div>
                      {selectedTemplate === template.id && <div className="w-5 h-5 rounded-full bg-[#8b5cf6] flex items-center justify-center" data-id="element-460">
                          <div className="w-2 h-2 rounded-full bg-white" data-id="element-461" />
                        </div>}
                    </div>

                    {/* Visual preview */}
                    <div className="mt-3 h-20 bg-[#0a0a0a] rounded-lg flex items-center justify-center" data-id="element-462">
                      <svg width="80" height="60" viewBox="0 0 80 60" data-id="element-463">
                        {template.id === 'rectangle' && <rect x="10" y="10" width="60" height="40" fill="none" stroke="#8b5cf6" strokeWidth="2" strokeDasharray="4,4" data-id="element-464" />}
                        {template.id === 'l-shape' && <path d="M 10 10 L 50 10 L 50 35 L 70 35 L 70 50 L 10 50 Z" fill="none" stroke="#8b5cf6" strokeWidth="2" strokeDasharray="4,4" data-id="element-465" />}
                        {template.id === 'u-shape' && <path d="M 10 10 L 70 10 L 70 50 L 55 50 L 55 25 L 25 25 L 25 50 L 10 50 Z" fill="none" stroke="#8b5cf6" strokeWidth="2" strokeDasharray="4,4" data-id="element-466" />}
                        {template.id === 'free' && <path d="M 15 30 L 30 15 L 50 20 L 65 35 L 55 50 L 25 45 Z" fill="none" stroke="#8b5cf6" strokeWidth="2" strokeDasharray="4,4" data-id="element-467" />}
                      </svg>
                    </div>
                  </motion.button>)}
              </div>

              <div className="mt-6 p-4 bg-[#2a2a2a] rounded-lg border border-[#333]" data-id="element-468">
                <p className="text-sm text-[#aaa]" data-id="element-469">
                  <strong className="text-white" data-id="element-470">Tip:</strong> Soffits are
                  ceiling drops that lower the ceiling height in specific areas.
                </p>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}